<script setup lang="ts">
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@manta/ui-kit';
import { useI18n } from 'vue-i18n';
import { SPECIES_KEYS, type SpeciesKey } from '@/lib/species';

defineProps<{
  modelValue: SpeciesKey | '';
}>();

const emit = defineEmits<{
  'update:modelValue': [value: SpeciesKey];
}>();

const { t } = useI18n();

function onChange(value: unknown) {
  const key = SPECIES_KEYS.find((k) => k === value);
  if (key) emit('update:modelValue', key);
}
</script>

<template>
  <Select :model-value="modelValue || undefined" @update:model-value="onChange">
    <SelectTrigger class="h-8 w-[130px] shrink-0 px-2 text-sm">
      <SelectValue :placeholder="t('workspace.patientForm.species')" />
    </SelectTrigger>
    <SelectContent>
      <SelectItem v-for="key in SPECIES_KEYS" :key="key" :value="key">
        {{ t(`workspace.species.${key}`) }}
      </SelectItem>
    </SelectContent>
  </Select>
</template>
